import React from 'react';
import {Control} from 'react-hook-form';
import cn from 'classnames';

import Edit from 'shared/ui/icons/General/Edit';

import Input, {InputProps} from './Input';
import {getInputClassName, InputStateIcon, useInputState} from './inputState';

import styles from './Input.module.scss';

export interface IInputTextProps extends InputProps {
    control: Control<any>;
    name: string,
    validate?: boolean;
    onClick?: () => void;
}

const InputText: React.FC<IInputTextProps> = ({
    control,
    className,
    validate = true,
    defaultValue,
    onClick,
    ...rest
}) => {
    const {state} = useInputState({control, name: rest.name, defaultValue, validate});

    return (
        <div className={styles.input_container}>
            <div className={styles.icon}>
                <InputStateIcon state={state} defaultIcon={<Edit width={16} height={16}/>}/>
            </div>
            <Input
                {...rest}
                onClick={onClick}
                type="text"
                className={cn(getInputClassName(styles, state), className)}
            />
        </div>
    );
};

export default InputText;
